import { NgModule, Component, Input, ChangeDetectionStrategy, PLATFORM_ID, Inject } from '@angular/core';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { DEVICE_INFO, DeviceInfo } from 'angular-engine/modules/ng-express-engine/tokens';

@Component({
    selector: 'spotlight',
    templateUrl: 'spotlight.template.html',
    styleUrls: ['spotlight.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpotlightComponent {
    @Input() featured:boolean = false;
    @Input() items: any;
    public isServer:boolean = false;
    public isPhone:boolean = false;

    /**
     * ContentList component
     */
    constructor(@Inject(PLATFORM_ID) platformId: string,
                @Inject(DEVICE_INFO) private deviceInfo: DeviceInfo) {
        this.isServer = isPlatformServer(platformId);
        this.isPhone = deviceInfo.isPhone;
    }

    ngOnInit() {
        if(this.items.length > 6)
        {
            this.items.length = 6;
        }
    }

    ngOnChanges() {
        if(this.items.length > 6)
        {
            this.items.length = 6;
        }
    }

    public get styleClass():string{
        return 'items-' + this.items.length + (this.featured ? ' featured': '');
    }

    public get fourItemLimit():number{
        return this.featured ? 2 : 1;
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/spotlight/spotlight.component.ts